<script lang="ts">
    import { changeToNightIcon, findClosestWeather, formatRain, formatSnow } from "../../Util/utils";
    import * as Dialog from "$lib/components/ui/dialog";
    import WeatherForecast from '../Calendar/WeatherForecast.svelte';
    import { buttonVariants } from "@/lib/components/ui/button";

    export let weather;
    export let dateTime

    //@ts-ignore
    let displayUnits = Xert._displayUnits;
    
    let date = new Date();
    let closestWeather
    let sunrise, sunset
    $: if(weather) {
        closestWeather = weather && dateTime ? findClosestWeather(weather.forecasts, dateTime) : null;
        date = new Date(closestWeather?.time*1000)
        sunrise = weather ? weather.sunrise : null
        sunset = weather ? weather.sunset: null
    }
</script>

{#if closestWeather !== null && closestWeather?.success && closestWeather?.temp && closestWeather?.icon_key && closestWeather?.description && closestWeather?.time}
<div class="box-solid">
    <div class="portlet light portlet-fit bordered full-height-content full-height-content-scrollable">
        <div class="portlet-title">
            <div class="title_container">
                <span class="box_header">Weather</span> 
                <div class="hidden md:block">
                    <Dialog.Root portal="#shadcn-ui-dialog-target">
                        <Dialog.Trigger class={buttonVariants({ variant: "ghost", size: "sm"})}>See Full Forecast</Dialog.Trigger>
                        <Dialog.Content class="max-h-[100dvh] max-w-fit overflow-auto">
                            <Dialog.Header>
                                <Dialog.Title>Weather Forecast</Dialog.Title>
                                <Dialog.Description>The full weather forecast for the day.</Dialog.Description>
                            </Dialog.Header>
                            <WeatherForecast weather={weather ? weather : null}/>
                        </Dialog.Content>
                    </Dialog.Root>
                </div>               
            </div>
            
        </div>
        <div class="weather-box">
            <div class="weather-group">
                <img class="weather-icon" width="40" height="40" src="/assets/images/weather-{changeToNightIcon(closestWeather.icon_key, closestWeather.time, sunrise, sunset)}.svg">
                <div class="vertical-stack">
                    {Math.round(closestWeather.temp)}&deg;
                    <span class="vertical-stack-small">POP: {Math.round(closestWeather.pop*100)}%</span>
                </div>
            </div>
            <div class="weather-group">
                {#if closestWeather.wind?.icon_key}
                <img class="wind-icon" src="/assets/images/weather-wind-{closestWeather.wind.icon_key}.svg">
                {/if}
                <div class="vertical-stack">
                    {#if closestWeather.wind?.speed != null}
                    {Math.round(closestWeather.wind.speed)} {displayUnits === "imperial" ? "mph" : "kph"}
                    {/if}
                    {#if closestWeather.wind?.gust != null}
                    <span class="vertical-stack-small">{Math.round(closestWeather.wind.gust)} {displayUnits === "imperial" ? "mph" : "kph"} gust</span>
                    {/if}
                </div>
            </div>
            <div class="weather-group">
                <div class="vertical-stack weather-description">
                    {#if closestWeather.rain}
                        {`Rain: ${formatRain(closestWeather.rain)}`}
                    {:else if closestWeather.snow}
                        {`Snow: ${formatSnow(closestWeather.snow)}`}
                    {:else}
                        {closestWeather.description}
                    {/if}
                    <span class="vertical-stack-small">{date.toUTCString().slice(0, date.toUTCString().lastIndexOf(" "))}</span>
                </div>
            </div>
        </div>
    </div>
</div>
{/if}

<style lang="scss">
    .wind-icon {
        transform: scale(1.5);
        margin-right: 8px;
    }

    .weather-icon {
        margin-right: 3px;
    }

    .weather-group {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .weather-box {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        margin: 0px 10px 10px 10px;
    }

    .vertical-stack {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 18px;
    }

    .vertical-stack-small {
        color: var(--color-xert-gray);
        font-size: 10px;
    }

</style>
